export const content = {
  title: "Swivelpole™ Cost Comparison Calculator",
  description:
    "This Swivelpole™ Cost Comparison Calculator is designed to demonstrate the cost savings in converting non-lowering walkway mounted poles to lowering poles using the Safe Swivel™ Joint (SSJ).  Savings are shown from installation through to total estimated savings over the lifecycle of a plant. Cost is based on the standard Safe Swivel™ Joint to suit DN50 pipe.",
  instructions:
    "Instructions: To use this calculator ensure that content has been enabled, fill in all of the cells shaded orange and press the Calculate Savings button."
};

export const inputs = [
  {
    id: 1,
    name: "pole_quantity",
    label: "Estimated number of poles"
  },
  {
    id: 2,
    name: "access_cost",
    label: "Estimated cost of access"
  },
  {
    id: 3,
    name: "electrian_cost",
    label: "Electrician cost per hour"
  },
  {
    id: 4,
    name: "maintenance_cycle",
    label: "Current maintenance cycle"
  },
  {
    id: 5,
    name: "unit_cost",
    label: "SSJ cost (indicative)",
    value: 300
  }
];

export const results = [
  {
    id: 6,
    name: "maintenance_cost",
    label: "Total estimated cost of current maintenance (per cycle)"
  },
  {
    id: 7,
    name: "install_cost",
    label: "Total estimated cost to install the SSJ"
  },
  {
    id: 8,
    name: "ongoing_cost",
    label:
      "Estimated ongoing cost of maintenance after installation of SSJ (per cycle)"
  },
  {
    id: 9,
    name: "estimated_saving",
    label: "Total estimated one time savings from installing the SSJ"
  },
  {
    id: 10,
    name: "estimated_lifecycle_saving",
    label:
      "Total estimated savings over 25 year asset lifecycle from installing the SSJ"
  }
];
